import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import type { IRedirect } from '../types/announcement';

/** Follows a navigation a controller asked for, once. */
export function useRedirect(redirect: IRedirect | null, clear: () => void): void {
  const navigate = useNavigate();
  useEffect(() => {
    if (!redirect) return;
    navigate(redirect.to, { replace: redirect.replace });
    clear();
  }, [redirect, clear, navigate]);
}
